import { useHandler } from "@redotech/react-util/hook";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { createContext, memo, ReactNode, useState } from "react";
import { MarkAsFulfilledModal } from "./mark-as-fulfilled-modal";

export const MarkAsFulfilledModalContext = createContext<
  (
    groups: readonly FulfillmentGroupData[],
    onGroupsFulfillment?: (groupIds: string[]) => void,
  ) => void
>(() => {});

export const MarkAsFulfilledModalProvider = memo(
  function MarkAsFulfilledModalProvider({ children }: { children: ReactNode }) {
    const [groups, setGroups] = useState<readonly FulfillmentGroupData[]>([]);
    const [open, setOpen] = useState(false);
    const [onGroupsFulfillment, setOnGroupsFulfillment] = useState<
      ((groupIds: string[]) => void) | undefined
    >();

    const openModalWithGroups = (
      newGroups: readonly FulfillmentGroupData[],
      onGroupsFulfillment?: (groupIds: string[]) => void,
    ) => {
      setGroups(newGroups);
      setOnGroupsFulfillment(() => onGroupsFulfillment);
      setOpen(true);
    };

    const onClose = useHandler(() => {
      setOpen(false);
      setGroups([]);
      setOnGroupsFulfillment(undefined);
    });

    return (
      <MarkAsFulfilledModalContext.Provider value={openModalWithGroups}>
        {children}
        {groups.length > 0 && (
          <MarkAsFulfilledModal
            groups={groups}
            onClose={onClose}
            onGroupsFulfillment={onGroupsFulfillment}
            open={open}
          />
        )}
      </MarkAsFulfilledModalContext.Provider>
    );
  },
);
